import PhoneNumber from 'awesome-phonenumber';

export const formatPhoneNumber = (phoneNumber) => {
    const regionCode = 'CA';

    if (!phoneNumber) {
        return '';
    }

    const formattedPhoneNumber = new PhoneNumber(String(phoneNumber), regionCode);
    const msisdn = formattedPhoneNumber.getNumber('national');

    if (!msisdn) {
        //Returning an empty string because the phone number could not be formatted
        return '';
    }

    return msisdn;
};

export const formatAccountNumber = (accountNumber, hyphen = false) => {
    accountNumber = String(accountNumber);

    const count = 4;
    const lastIndex = accountNumber.length - 1;

    let result = '';
    let start = -1;
    let end = 0;

    let ch;
    do {
        start++;
        ch = accountNumber.charAt(start);
    } while (ch === '0' && start < lastIndex);

    do {
        end = start + count;
        result += accountNumber.substring(start, end);
        start += count;
        if (start < lastIndex) {
            result += hyphen ? '-' : ' ';
        }
    } while (end < lastIndex);
    return result;
};
